/**
 * 组件的props
 */
export const props = {
  /**
   * 是否处于加载状态，加载过程中不触发 load 事件
   * @default false
   */
  loading: {
    type: Boolean,
    default: false,
  },

  /**
   * 加载过程中的提示文案
   * @default '加载中...'
   */
  loadingText: {
    type: String,
    default: '加载中...',
  },

  /**
   * 是否已加载完成，完成后不再触发 load 事件
   * @default false
   */
  finished: {
    type: Boolean,
    default: false,
  },

  /**
   * 加载完成后的提示文案
   * @default ''
   */
  finishedText: {
    type: String,
    default: '',
  },

  /**
   * 是否加载失败
   * @default false
   */
  error: {
    type: Boolean,
    default: false,
  },

  /**
   * 加载失败时的提示文案
   * @default '加载失败，点击重试'
   */
  errorText: {
    type: String,
    default: '加载失败，点击重试',
  },
};

